import { render } from "./GoalTimingPage.vue?vue&type=template&id=2641d475&scoped=true&ts=true"
import script from "./GoalTimingPage.vue?vue&type=script&lang=ts"
export * from "./GoalTimingPage.vue?vue&type=script&lang=ts"

import "./GoalTimingPage.vue?vue&type=style&index=0&id=2641d475&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2641d475"]])

export default __exports__